import { types } from "../types";

export const authReducer = (state = {}, action) => {
  switch (action.type) {
    case types.login:
      localStorage.setItem("token", action.payload.token); //<--- No lo debo hacer
      return {
        ...state,
        // token: action.payload.token,//Borrar //lo recibo de la peticion a la API
        authenticated: true
      };

    case types.getUser:
      return {
        ...state,
        authenticated: true,
        user: action.payload
      }

    case types.logout:
      localStorage.removeItem("token"); //<--- No lo debo hacer 
      return {
        authenticated: null,
      };

    default:
      return state;
  }
};
